import { FormControl, FormHelperText, InputLabel, OutlinedInput } from "@mui/material";
import { forwardRef } from "react";
import { Controller, UseFormReturn } from "react-hook-form";
import { IMaskInput } from "react-imask";

/**
 * FormCPFMaskedInputBase
 */
interface CustomProps {
  onChange: (event: { target: { name: string; value: string } }) => void;
  name: string;
  mask: string;
}

const FormCPFMaskedInputBase = forwardRef<HTMLInputElement, CustomProps>((props, refs) => {
  const { onChange, ...other } = props;
  return (
    <IMaskInput
      {...other}
      placeholderChar="_"
      inputRef={refs}
      onAccept={(value: any, input: { unmaskedValue: string }) => {
        if (input.unmaskedValue.length > 0) {
          onChange({ target: { name: props.name, value } });
        } else {
          onChange({ target: { name: props.name, value: '' } });
        }
      }}
      lazy={false}
      overwrite={true}
      unmask={false}
    />
  );
});


/**
 * FormCPFMaskedInput
 */

type Props<T extends {}> = {
  name: keyof T,
  label: string,
  required?: boolean,
  readOnly?: boolean,
  reactHookForm: UseFormReturn<T>,
};

export const FormCPFMaskedInput = <T extends {},>({
  name,
  label,
  required,
  readOnly,
  reactHookForm,
}: Props<T>) => {
  return (
    <Controller
      name={name as any}
      control={reactHookForm.control}
      render={({ field, formState }) => {
        let helperText: string | null = null;

        if (name in formState.errors) {
          const error = formState.errors[name] as any;
          if (typeof error.message === 'string') {
            helperText = error.message;
          }
        }

        return (
          <FormControl variant="outlined" size="small">
            <InputLabel
              htmlFor={`input-${name as string}`}
              size="small"
              shrink={true}
              error={helperText !== null}
              required={required}>
              {label}
            </InputLabel>

            <OutlinedInput
              size="small"
              id={`input-${name as string}`}
              error={helperText !== null}
              aria-describedby={`${name as string}-component-error-text`}
              label={label}
              notched={true}
              required={required}
              readOnly={readOnly}
              disabled={formState.disabled}
              inputComponent={FormCPFMaskedInputBase as any}
              inputProps={{
                ...field,
                value: field.value,
                mask: '000.000.000-00',
                placeholder: "___.___.___-__",
                required: required,
              }} />

            <FormHelperText id={`${name as string}-component-error-text`} error={true}>
              {helperText}
            </FormHelperText>
          </FormControl>
        )
      }} />
  );
}